import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Grid } from '@app/core/components/grid/grid.model';
import { GridButton, GridOptions, GridRow, GridRowButton, GridToolbarButton } from '@app/core/components/grid/grid.types';
import { ModalService } from '@app/core/services/modal.service';
import { CreateMaterialCertificateResponse } from './matcert-create/matcert-create.component';

@Component({
    selector: 'tt-oh-material-certificates',
    templateUrl: './oh-material-certificates.component.html',
    styleUrls: ['./oh-material-certificates.component.css'],
})
export class OhMaterialCertificatesComponent implements OnChanges {
    @Input()
    public params?: { order_internal_no: string };

    public grid?: GridOptions;

    @Output()
    public gridReady = new EventEmitter<GridOptions>();

    constructor(private modal: ModalService) {}

    private readGrid() {
        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId(' w_orderhead_matcert_grid')
                .setLoadDataFunction({ method: 3931, parameters: () => this.params })
                .setCustomToolbarButtons([this.buildCreateMatCertButton()])
                .setSpecialFunc({ buttons: [this.buildMatCertRowButton()] });
        } else {
            this.grid.gridfunc?.read();
        }
    }

    private buildCreateMatCertButton(): GridToolbarButton {
        return {
            name: 'create_matcert',
            text: 'oh_matcert_create',
            translate: true,
            icon: 'fas fa-plus',
            cssClass: 'im-grid-btn-xs-l tt-button tt-button--primary',
            func: async () => {
                const response: CreateMaterialCertificateResponse | undefined = await this.modal.openStateDialog({ state: 'matcertcreate', params: '' + this.params!.order_internal_no });

                if (response?.errorcode === '0') {
                    this.readGrid();
                    this.openMatcertModal(response.matcert_keyno);
                }
            },
        };
    }

    private buildMatCertRowButton(): GridRowButton {
        return {
            name: 'open_matcert',
            tooltip: 'open_matcert',
            translateTooltip: true,
            icon: 'fas fa-pen',
            btn_type: 'primary',
            func: (row: GridRow) => {
                this.openMatcertModal('' + row['matcert_keyno']);
            },
        };
    }

    private async openMatcertModal(matcertKeyno: string) {
        const response = await this.modal.openStateDialog({ state: 'matcert', params: '' + matcertKeyno });

        if (!!response) {
            this.grid?.gridfunc?.read();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['params']) {
            this.readGrid();
        }
    }
}
